
const portalURL =
  window.Liferay?.ThemeDisplay?.getPortalURL() || window.location.origin;

const docBase = `${portalURL}/documents/d/provider-search`;

// Build the liferay document library URL dynamically and Set CSS variables globally
document.documentElement.style.setProperty(
  "--banner-container", `url(${docBase}/banner-container)`
);
document.documentElement.style.setProperty(
  "--heartbeat-icon", `url(${docBase}/heartbeat-icon)`
);
document.documentElement.style.setProperty(
  "--oncology-icon", `url(${docBase}/oncology-icon)`
);
document.documentElement.style.setProperty(
  "--orthopedics-icon", `url(${docBase}/orthopedics)`
);
document.documentElement.style.setProperty(
  "--bars-icon", `url(${docBase}/bars-icon)`
);
document.documentElement.style.setProperty(
  "--infinite-icon", `url(${docBase}/infinite-icon)`
);
document.documentElement.style.setProperty(
  "--spinal-icon", `url(${docBase}/spinal-icon)`
);
document.documentElement.style.setProperty(
  "--download-icon", `url(${docBase}/download)`
);

//--download-icon

// this variables can used accross the components
export const assets = {
  bannerImage: `${docBase}/banner-container`,
  searchLoader: `${docBase}/provider-search-loader`,
  spriteIcons: `${docBase}/icons`,
};